import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import StatsPanelPercentageBar from "../StatsPanelPercentageBar";
import StatsMessage from "../StatsMessage";
import styles from "./StatsPanel.module.scss";

const StatsPanel = ({
  homeTeamName,
  awayTeamName,
  marketType,
  stats,
  toggleStatsPanel,
  selectionName,
  selectionType,
  type,
}) => {
  const { onboardingStep } = useSelector((state) => state.filter);
  const getTeamName = (type) => {
    if (type === "home") return homeTeamName;
    if (type === "away") return awayTeamName;

    return null;
  };

  return (
    <div
      className={`${styles.statsPanel} ${
        toggleStatsPanel || onboardingStep === 5
          ? styles["statsPanel--open"]
          : ""
      }`}
      data-testid={`stats-${marketType}-${homeTeamName}-${awayTeamName}`}
    >
      <div className={styles.statsPanelInner}>
        {stats?.map((stat) => (
          <div key={stat.type} className={styles.statsRow}>
            <div className={styles.statsRowTeam}>{getTeamName(stat.type)}</div>
            <StatsPanelPercentageBar {...stat} />
          </div>
        ))}
        <StatsMessage
          marketType={marketType}
          selectionName={selectionName}
          selectionType={selectionType}
          toggleStatsPanel={toggleStatsPanel}
          type={type}
          statsLength={stats?.length}
          statsTeamType={stats?.find((stat) => stat)?.type}
        />
      </div>
    </div>
  );
};

StatsPanel.propTypes = {
  homeTeamName: PropTypes.string,
  awayTeamName: PropTypes.string,
  marketType: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      numberOfMatches: PropTypes.number,
      numberOfWins: PropTypes.number,
      probability: PropTypes.number,
      type: PropTypes.string,
    })
  ),
  toggleStatsPanel: PropTypes.bool,
  selectionName: PropTypes.string,
  selectionType: PropTypes.string,
  type: PropTypes.string,
};

export default StatsPanel;
